var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOnline)?_c('v-icon',{attrs:{"title":"Connected","color":"primary","dense":""}},[_vm._v("mdi-access-point-network")]):_c('v-icon',{attrs:{"title":"Disconnected","disabled":"","dense":""}},[_vm._v("mdi-access-point-network-off")])
}
var staticRenderFns = []

export { render, staticRenderFns }